import { useEffect } from "react";

const useDessableZoom = () => {
  useEffect(() => {
    /******* zoom web *******/
    const handleKeyDownZoom = (event: KeyboardEvent) => {
      if (event.ctrlKey || event.metaKey) {
        if (
          event.key === "=" ||
          event.key === "+" ||
          event.key === "-" ||
          event.key === "0"
        ) {
          event.preventDefault();
        }
      }
    };
    // Prevenir zoom con la rueda del ratón
    // Manejar la combinación Ctrl + Scroll para deshabilitar el zoom
    const handleWheel = (event: WheelEvent) => {
      if (event.ctrlKey || event.metaKey) {
        event.preventDefault();
      }
    };
    //Zoom web
    window.addEventListener("keydown", handleKeyDownZoom);
    window.addEventListener("wheel", handleWheel, { passive: false });
    /******* end zoom web ******/

    return () => {
      //zom web
      window.removeEventListener("keydown", handleKeyDownZoom);
      window.removeEventListener("wheel", handleWheel);
    };
  }, []);
};

export default useDessableZoom;
